module.exports = __webpack_public_path__ + "static/media/logo-람다256@3x.daf17b82.png";